export default __webpack_public_path__ + "static/media/52.db053f2e.png";